var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('menu-toggle-button',{attrs:{"is-open":_vm.menuIsVisible,"is-mimovrste":_vm.isSlovenia,"translations":_vm.translations},on:{"click":_vm.toggleMainMenuOpen}})
}
var staticRenderFns = []

export { render, staticRenderFns }